import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import EternalElegance from './templates/EternalElegance';
import ModernVows from './templates/ModernVows';
import ee from './assets/ee.png';
import mv from './assets/mv.png';
import bb from './assets/bb.png';
import BlissfulBond from './templates/BlissfulBond';
import ContactTile from './ContactTile';

const LandingPage = () => {
  return (
    <div className="poppins flex min-h-screen flex-col items-center bg-white px-4">
      <header className="w-full bg-white py-4">
        <div>
          <h1 className="mx-2 flex justify-end text-base font-bold md:text-lg lg:text-xl">
            <span className="rounded-lg bg-black px-4 py-1 text-white">
              <a
                href="https://www.tailwine.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                Tailwine Studio
              </a>
            </span>
          </h1>
        </div>
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
            Explore our exquisite wedding templates designed just for you. If
            you're interested, drop us an email at{' '}
            <a href="mailto:team@tailwine.in" className="underline">
              team@tailwine.in
            </a>
            .
          </p>
        </div>
      </header>
      <main className="w-full max-w-6xl flex-grow">
        <div className="mt-8 grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
          <Tile route="/eternal-elegance" title="Eternal Elegance" image={ee} />
          <Tile route="/modern-vows" title="Modern Vows" image={mv} />
          <Tile route="/blissful-bond" title="Blissful Bond" image={bb} />
          <ContactTile />
        </div>
      </main>
      <footer className="mt-8 w-full border-t border-gray-200 bg-white py-4">
        <p className="text-center text-sm text-gray-600">
          Made with <span className="text-red-500">❤️</span> by Tailwine Studio
          &amp; Mehta
        </p>
      </footer>
    </div>
  );
};

const Tile = ({ route, title, image }) => {
  return (
    <Link
      to={route}
      className="group relative block overflow-hidden rounded-lg shadow-md"
    >
      <img
        src={image}
        alt={title}
        className="h-64 w-full object-cover transition-transform duration-300 group-hover:scale-110"
      />
      <h2 className="absolute bottom-4 left-4 text-xl font-bold text-white transition-transform duration-300 group-hover:scale-110">
        {title}
      </h2>
    </Link>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/eternal-elegance" element={<EternalElegance />} />
        <Route path="/modern-vows" element={<ModernVows />} />
        <Route path="/blissful-bond" element={<BlissfulBond />} />
      </Routes>
    </Router>
  );
};

export default App;
